import script from "./InheritanceRedactor.vue?vue&type=script&setup=true&lang=js"
export * from "./InheritanceRedactor.vue?vue&type=script&setup=true&lang=js"

import "./InheritanceRedactor.vue?vue&type=style&index=0&id=47e49b6d&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47e49b6d"]])

export default __exports__